import { render, staticRenderFns } from "./Database.vue?vue&type=template&id=c5c9f20c&scoped=true&"
import script from "./Database.vue?vue&type=script&lang=js&"
export * from "./Database.vue?vue&type=script&lang=js&"
import style0 from "./Database.vue?vue&type=style&index=0&id=c5c9f20c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c9f20c",
  null
  
)

export default component.exports